import { render, staticRenderFns } from "./PracticeTestReports.vue?vue&type=template&id=73011b72&"
import script from "./PracticeTestReports.vue?vue&type=script&lang=js&"
export * from "./PracticeTestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports